<template>
<!-- vendor test link -->
<!-- 0x3d509b1f6582fbe9724c737d7d3b918eb3cc9a33d79d33fa09ce43fd4cd351b5 -->
<!-- product test link -->
<!-- 0x26266454ef5056077b0ed232c3d9b35a04966f69821f0cefdf365d31e45bf485 -->
  <div class="invocation-event">
    <div v-if="!isEmpty">
      <!-- vendor -->
      <div class="card" v-if="isDeployVendor">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-6">
                <a v-bind:href="'#/account/' + args.owner">
                  {{ args.name }}
                </a>
              </p>
            </div>
          </div>

          <div class="content">
            {{ args.desc }}
            <br>
            <time datetime="2016-1-1">{{ $utils.formatTimestamp(args.timestamp) }}</time>
          </div>
        </div>
      </div>
      <!-- product -->
      <div class="card product" v-if="isProduct">
        <div class="card-image">
          <figure class="image is-square">
            {{ videoUrl = args.image + '?vframe/jpg/offset/1/w/180/h/320'}}
            <a :href="args.image" v-if="args.image.includes('.mp4')">
              <img :src="videoUrl" alt="Placeholder video">
            </a>
            <img :src="args.image" alt="Placeholder image" v-else>
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">
                {{ args.name }}
              </p>
              <p class="subtitle is-6">
                <barcode
                  :value="args.barcode"
                  height="60"
                  lineColor="#363636">Invalid Barcode</barcode>
              </p>
            </div>
          </div>
          <div class="content">
            {{ args.desc }}
            <br>
            <time datetime="2016-1-1">{{ $utils.formatTimestamp(args.timestamp) }}</time>
          </div>
        </div>
      </div>
      <!-- add operation -->
      <div class="card product" v-if="isAddOperation">
        <div class="card-image">
          <figure class="image is-square">
            <img :src="args.image" alt="Placeholder image">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">
                {{ args.name }}
              </p>
            </div>
          </div>
          <div class="content">
            {{ args.desc }}
            <br>
            <time datetime="2016-1-1">{{ $utils.formatTimestamp(args.timestamp) }}</time>
          </div>
        </div>
      </div>
      <!-- product item -->
      <!-- TODO -->

      <!-- end of content -->
    </div>
  </div>
</template>

<script>
  import VueBarCode from 'vue-barcode'

  export default {
    name: 'extra-event',
    props: ['extra'],
    components: {
      'barcode': VueBarCode
    },
    computed: {
      isEmpty () {
        return this.$_.isEmpty(this.extra)
      },
      isDeployVendor () {
        return (!this.$_.isEmpty(this.extra) && this.extra.method === 'deployVendor')
      },
      isProduct () {
        return (!this.$_.isEmpty(this.extra) && this.extra.method === 'deployProduct')
      },
      isAddOperation () {
        return (!this.$_.isEmpty(this.extra) && this.extra.method === 'addOperation')
      },
      args () {
        return this.extra.arguments
      }
    }
  }
</script>

<style lang="scss" scoped>
  .owner {
    font-size: 0.75rem
  }
  .product {
    figure {
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/ExtraEvent.vue